"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAuthUtils = initAuthUtils;
exports.refreshToken = refreshToken;
const ioredis_1 = __importDefault(require("ioredis"));
const SERVICE_PREFIX = 'auth-utils';
const DEFAULT_LOCK_TTL_MS = 5000;
const DEFAULT_REFRESHED_TOKEN_TTL_SEC = 60;
const scope = global;
async function initAuthUtils({ redis: { port, host, prefix = '' }, refreshToken, logger, lockTtlMs, refreshedTokenTtlSec, }) {
    const redisPrefix = `${prefix}-${SERVICE_PREFIX}`;
    if (scope.authUtils) {
        return;
    }
    const setClientName = (redis, name) => redis
        .client('SETNAME', name)
        .catch((e) => logger === null || logger === void 0 ? void 0 : logger.error('Auth utils CLIENT SETNAME error:', e));
    try {
        const redis = new ioredis_1.default(port, host);
        setClientName(redis, `${redisPrefix}:commands`).catch();
        const channelName = `${redisPrefix}:token-refreshed`;
        scope.authUtils = {
            redis,
            redisPrefix,
            channelName,
            subscriptions: {},
            refreshToken,
            logger,
            lockTtlMs: lockTtlMs || DEFAULT_LOCK_TTL_MS,
            refreshedTokenTtlSec: refreshedTokenTtlSec || DEFAULT_REFRESHED_TOKEN_TTL_SEC,
        };
        const subscriber = new ioredis_1.default(port, host);
        setClientName(subscriber, `${redisPrefix}:subscriptions`).catch();
        await subscriber.subscribe(channelName);
        subscriber.on('message', (_, tokens) => {
            const [oldToken, newToken] = tokens.split(':');
            onTokenRefreshed(oldToken, newToken);
        });
    }
    catch (e) {
        logger === null || logger === void 0 ? void 0 : logger.error('Init auth utils error:', e);
    }
}
async function refreshToken(token) {
    if (!scope.authUtils) {
        throw new Error('Auth utils is not initialized');
    }
    const { redis, redisPrefix, channelName, logger, refreshToken, lockTtlMs, refreshedTokenTtlSec, } = scope.authUtils;
    const tokenKey = `${redisPrefix}:token:${token}`;
    const newToken = await redis.get(tokenKey);
    if (newToken) {
        return { refreshedToken: newToken };
    }
    const lockKey = `${redisPrefix}:lock:${token}`;
    const lock = async () => !!await redis.setnx(lockKey, new Date().getTime());
    let lockAcquired = await lock();
    if (!lockAcquired) {
        const lockTime = +redis.get(lockKey);
        const unlockKey = `${redisPrefix}:unlock:${token}`;
        const unlockAcquired = await redis.setnx(unlockKey, '');
        try {
            if (unlockAcquired &&
                new Date().getTime() - lockTime > lockTtlMs) {
                redis.del(lockKey);
                lockAcquired = await lock();
            }
        }
        finally {
            redis.del(unlockKey);
        }
    }
    if (lockAcquired) {
        const setRefreshed = async (refreshed) => {
            redis.setex(tokenKey, refreshedTokenTtlSec, refreshed);
            redis.publish(channelName, `${token}:${refreshed}`);
            redis.del(lockKey);
        };
        try {
            const res = await refreshToken(token);
            await setRefreshed(res.refreshedToken || '');
            return res;
        }
        catch (e) {
            logger === null || logger === void 0 ? void 0 : logger.error('Refresh token error:', e);
            await setRefreshed('');
            return { refreshedToken: '' };
        }
    }
    else {
        return { refreshedToken: await waitForTokenRefreshed(token) };
    }
}
function waitForTokenRefreshed(token) {
    const subscriptions = scope.authUtils.subscriptions;
    const tokenSubscriptions = subscriptions[token] || (subscriptions[token] = []);
    let resolve;
    const promise = new Promise(p => resolve = p);
    tokenSubscriptions.unshift(resolve);
    return promise;
}
function onTokenRefreshed(oldToken, newToken) {
    const subscriptions = scope.authUtils.subscriptions;
    const tokenSubscriptions = subscriptions[oldToken];
    if (!tokenSubscriptions) {
        return;
    }
    let subscription;
    while ((subscription = tokenSubscriptions.pop())) {
        subscription(newToken);
    }
    delete subscriptions[oldToken];
}
//# sourceMappingURL=authUtils.js.map